import { SegmentFilter } from '../segmentFilters';
import { StatItemProps } from './SegmentItem';
import { SegmentedBar, StatRow, WIDGET_COLORS, WidgetCard, WidgetTooltip } from './WidgetPrimitives';

// Shared by the bar segment and the stat below it so both toggle the same filter.
const passportFilter = (status: string, label: string): SegmentFilter => ({
  attribute: 'passport_status',
  value: status,
  group: 'Educator Passport',
  label
});

const passportStat = (
  percent: number,
  status: string,
  label: string,
  color?: string
): StatItemProps => ({
  value: `${percent}%`,
  label,
  color,
  filter: passportFilter(status, label)
});

export interface EducatorPassportWidgetData {
  total_count?: number;
  counts?: {
    complete?: number;
    in_progress?: number;
    incomplete?: number;
  };
  percentages?: {
    complete?: number;
    in_progress?: number;
    incomplete?: number;
  };
}

interface EducatorPassportWidgetProps {
  data: EducatorPassportWidgetData;
}

const TOOLTIP = (
  <WidgetTooltip
    heading="Educator Passport"
    description="Shows Educator progress towards achieving a Passport."
    definitions={[
      { term: 'Complete', description: 'Educators who have achieved their Passport.', color: WIDGET_COLORS.green },
      {
        term: 'In Progress',
        description: 'Educators who have commenced Passport activities but have not yet completed all requirements.',
        color: WIDGET_COLORS.blue
      },
      { term: 'Incomplete', description: 'Educators who have not started any Passport activities.' }
    ]}
    note="The total number includes only the educators you supervise."
  />
);

const EducatorPassportWidget = ({
  data: {
    total_count: total = 0,
    counts: { complete: completeCount = 0, in_progress: inProgressCount = 0, incomplete: incompleteCount = 0 } = {},
    percentages: { complete: completePercent = 0, in_progress: inProgressPercent = 0, incomplete: incompletePercent = 0 } = {}
  }
}: EducatorPassportWidgetProps) => (
  <WidgetCard title="Educator Passport" total={total} tooltip={TOOLTIP}>
    <SegmentedBar
      segments={[
        {
          percent: completePercent,
          color: WIDGET_COLORS.green,
          label: 'Complete',
          count: completeCount,
          filter: passportFilter('complete', 'Complete')
        },
        {
          percent: inProgressPercent,
          color: WIDGET_COLORS.blue,
          label: 'In progress',
          count: inProgressCount,
          filter: passportFilter('in_progress', 'In progress')
        }
      ]}
      remainder={{
        label: 'Incomplete',
        percent: incompletePercent,
        count: incompleteCount,
        filter: passportFilter('incomplete', 'Incomplete')
      }}
    />
    <StatRow
      items={[
        passportStat(completePercent, 'complete', 'Complete', WIDGET_COLORS.green),
        passportStat(inProgressPercent, 'in_progress', 'In progress', WIDGET_COLORS.blue),
        passportStat(incompletePercent, 'incomplete', 'Incomplete')
      ]}
    />
  </WidgetCard>
);

export default EducatorPassportWidget;
